module.exports = __webpack_public_path__ + "static/media/page-break.1b02f9b1.svg";